var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "222px",
    height: "211px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -249 -772 )"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 249 772  L 471 772  L 471 983  L 249 983  L 249 772  ",
    fillRule: "nonzero",
    fill: "#cccccc",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 264 787  L 456 787  L 456 968  L 264 968  L 264 787  ",
    fillRule: "nonzero",
    fill: "#ffffff",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 380.265 835.3  C 371.403 835.3  364.44 828.337  364.44 819.475  C 364.44 810.613  371.403 803.65  380.265 803.65  C 389.127 803.65  396.09 810.613  396.09 819.475  C 396.09 828.337  389.127 835.3  380.265 835.3  ",
    fillRule: "nonzero",
    fill: "#cccccc",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 270 963  L 270 869.5  L 315.25 827  L 378.6 866.054054054054  L 414.8 852.5  L 451 866.054054054054  L 451 963  L 270 963  ",
    fillRule: "nonzero",
    fill: "#169bd5",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.6a90133791d9a1c315f4d814d58c4f31.svg";
export { ForwardRef as ReactComponent };